import { Page } from '@epilot/customer-portal-client'

export const generateRoutes = (pages: Page[]): Page[] => {
  const routes = []

  if (!pages?.length) {
    return routes
  }

  if (!pages?.length) {
    return routes
  }

  pages.forEach((page) => {
    let path = `/${page.slug}`

    if (page.slug === '') {
      path = '/'
    }

    if (page.slug && !page.slug.startsWith('/')) {
      path = `/${page.slug}`
    }

    if (page.parentId) {
      const parent = pages.find((p) => p.id === page.parentId)

      if (parent) {
        path = `/${parent.slug}/${page.slug}`
      }
    }

    routes.push({ ...page, path: `${path}`, id: page.id, exact: true })
  })

  const sortedRoutes = routes.sort((a, b) => {
    const aSegments = (a.path?.split('/') || []).length
    const bSegments = (b.path?.split('/') || []).length

    return bSegments - aSegments
  })

  return sortedRoutes
}

export const findPageByPath = (
  pages: Page[],
  pathname: string
): Page | null => {
  if (!pages?.length) return null

  const exactMatch = pages.find((page) => {
    const pagePath = page.path === '' ? '/' : page.path

    return pagePath === pathname
  })

  if (exactMatch) return exactMatch

  for (const page of pages) {
    const pagePath = page.path === '' ? '/' : page.path

    const pageSegments = pagePath.split('/')
    const pathSegments = pathname.split('/')

    if (pageSegments.length === pathSegments.length) {
      const matches = pageSegments.every((segment, index) => {
        return segment === pathSegments[index]
      })

      if (matches) return page
    }

    if (page.path.includes(pathname)) return page
  }

  return null
}

/**
 * Matches `pathname` against each page's `past_routes` (slugs the page
 * previously used). Returns the page whose current path should receive the
 * redirect. Handles nested pages by swapping only the final path segment.
 */
export const findPageByPastRoute = (
  pages: Page[],
  pathname: string
): Page | null => {
  if (!pages?.length || !pathname) return null

  for (const page of pages) {
    const pastRoutes = (page as Page & { past_routes?: string[] }).past_routes

    if (!Array.isArray(pastRoutes) || !pastRoutes.length || !page.path) continue

    const pathSegments = page.path.split('/')

    for (const pastSlug of pastRoutes) {
      if (!pastSlug) continue

      const candidate = [...pathSegments.slice(0, -1), pastSlug].join('/')

      if (candidate === pathname) return page
    }
  }

  return null
}
